<template>
  <div class="popup_wrap" style="width:1750px;">
    <button class="layer_close" @click.prevent="layerClose()">close</button>
    <div class="popup_cont">
      <h1 class="page_title">{{ $t('cp.CTRL020P170.001') }}</h1>
      <div class="content_box mt10">
        <div class="cp-popinfo">
          <div>
            <span>{{ $t('cp.CTRL020P170.002') }}</span>
            <span>{{ parentInfo.sfOpt.scenarioNm }}</span>
          </div>
          <div>
            <span>{{ $t('cp.CTRL020P170.003') }}</span>
            <span>{{ parentInfo.sfOpt.effectTo }}</span>
          </div>
          <div>
            <span>{{ $t('cp.CTRL020P170.004') }}</span>
            <span>{{ $t('cp.CTRL020P170.005') }}</span>
          </div>
          <div></div>
        </div>
      </div>
      <div class="content_box cp-parentnode">
        <div id="realgrid" style="width: 100%; height: 482px" />
      </div>
      <div class="text_center mt10">
        <a class="button blue lg" href="#" @click.prevent="asyncAlert($t('cp.CTRL020P170.006'))">{{ $t('cp.COMMON.011') }}</a>
        <a class="button blue lg" href="#" @click.prevent="layerClose()">{{ $t('cp.COMMON.007') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import cpCommonInfo from '@/api/rest/cp/cpCommonInfo'
  import scenarioTargetSet from '@/api/rest/cp/scenarioTargetSet'
  import { createGrid } from '@/plugins/realgridUtil'

  let gridView = null
  let provider = null

  const countryfield = { fieldName: 'country', dataType: 'text' }

  const fields = [
    { fieldName: 'promotionOwner', dataType: 'text' },
    { fieldName: 'sfCntrSz', dataType: 'text' },
    { fieldName: 'sfCntrTyp', dataType: 'text' },
    { fieldName: 'sfRoute', dataType: 'text' },
    { fieldName: 'sfLostReason', dataType: 'text' },
    { fieldName: 'sfCargoTyp', dataType: 'text' },
    { fieldName: 'sfVsl', dataType: 'text' },
    { fieldName: 'sfVoyage', dataType: 'text' },
    { fieldName: 'teuTgt', dataType: 'number', subType: 'uint' },
    { fieldName: 'revTeuTgt', dataType: 'number', subType: 'uint' },
    { fieldName: 'cm1TeuTgt', dataType: 'number', subType: 'uint' }
  ]

  // https://docs.realgrid.com/refs/template-cell-renderer
  // eslint-disable-next-line
  const countryColumn = { name: 'country', fieldName: 'country', header: { text: app.$t('cp.CTRL020P170.007') }, width: 80, editable: false, renderer: { type: 'html', template: '${value:porCtr}' } }

  const columns = [
    { name: 'promotionOwner', fieldName: 'promotionOwner', type: 'text', header: { text: app.$t('cp.CTRL020P170.008') }, width: 100, editable: false },
    {
      name: 'sfCntrSz',
      fieldName: 'sfCntrSz',
      header: {
        text: app.$t('cp.CTRL020P170.022'),
        styleName: 'cp-tgt-header'
      },
      width: 100,
      editable: true,
      editor: {
        type: 'list',
        dropDownPosition: 'editor',
        values: [],
        displayLabels: 'value',
        dropDownWhenClick: true,
        domainOnly: true,
        textReadOnly: false
      },
      styleName: 'cp-tgt-column'
    },
    {
      name: 'sfCntrTyp',
      fieldName: 'sfCntrTyp',
      header: {
        text: app.$t('cp.CTRL020P170.023'),
        styleName: 'cp-tgt-header'
      },
      width: 100,
      editable: true,
      editor: {
        type: 'list',
        dropDownPosition: 'editor',
        values: [],
        displayLabels: 'value',
        dropDownWhenClick: true,
        domainOnly: true,
        textReadOnly: false
      },
      styleName: 'cp-tgt-column'
    },
    {
      name: 'sfRoute',
      fieldName: 'sfRoute',
      header: {
        text: app.$t('cp.CTRL020P170.024'),
        styleName: 'cp-tgt-header'
      },
      width: 100,
      editable: true,
      editor: {
        type: 'list',
        dropDownPosition: 'editor',
        values: [],
        displayLabels: 'value',
        dropDownWhenClick: true,
        domainOnly: true,
        textReadOnly: false
      },
      styleName: 'cp-tgt-column'
    },
    {
      name: 'sfVsl',
      fieldName: 'sfVsl',
      header: {
        text: app.$t('cp.CTRL020P170.025'),
        styleName: 'cp-tgt-header'
      },
      width: 100,
      editable: true,
      editor: {
        type: 'list',
        dropDownPosition: 'editor',
        values: [],
        displayLabels: 'value',
        dropDownWhenClick: true,
        domainOnly: true,
        textReadOnly: false
      },
      styleName: 'cp-tgt-column'
    },
    { name: 'sfVoyage', fieldName: 'sfVoyage', header: { text: app.$t('cp.CTRL020P170.026'), styleName: 'cp-tgt-header' }, width: 100, editable: true, editor: { type: 'text' }, styleName: 'cp-tgt-column' },
    {
      name: 'sfLostReason',
      fieldName: 'sfLostReason',
      header: {
        text: app.$t('cp.CTRL020P170.027'),
        styleName: 'cp-tgt-header'
      },
      width: 100,
      editable: true,
      editor: {
        type: 'list',
        dropDownPosition: 'editor',
        values: [],
        displayLabels: 'value',
        dropDownWhenClick: true,
        domainOnly: true,
        textReadOnly: false
      },
      styleName: 'cp-tgt-column'
    },
    {
      name: 'sfCargoTyp',
      fieldName: 'sfCargoTyp',
      header: {
        text: app.$t('cp.CTRL020P170.028'),
        styleName: 'cp-tgt-header'
      },
      width: 100,
      editable: true,
      editor: {
        type: 'list',
        dropDownPosition: 'editor',
        values: [],
        displayLabels: 'value',
        dropDownWhenClick: true,
        domainOnly: true,
        textReadOnly: false
      },
      styleName: 'cp-tgt-column'
    },
    { name: 'teuTgt', fieldName: 'teuTgt', header: { text: app.$t('cp.CTRL020P170.009'), styleName: 'cp-tgt-header' }, width: 100, numberFormat: '0', editable: true, editor: { type: 'number', positiveOnly: true, integerOnly: true }, styleName: 'cp-tgt-column' },
    { name: 'revTeuTgt', fieldName: 'revTeuTgt', header: { text: app.$t('cp.CTRL020P170.010'), styleName: 'cp-tgt-header' }, width: 100, numberFormat: '0', editable: true, editor: { type: 'number', positiveOnly: true, integerOnly: true }, styleName: 'cp-tgt-column' },
    { name: 'cm1TeuTgt', fieldName: 'cm1TeuTgt', header: { text: app.$t('cp.CTRL020P170.011'), styleName: 'cp-tgt-header' }, width: 100, numberFormat: '0', editable: true, editor: { type: 'number', positiveOnly: true, integerOnly: true }, styleName: 'cp-tgt-column' }
  ]

  const layout = [
    'promotionOwner',
    {
      name: 'keyInfo',
      direction: 'horizontal',
      items: [
        'sfCntrSz',
        'sfCntrTyp',
        'sfRoute',
        'sfVsl',
        'sfVoyage',
        'sfLostReason',
        'sfCargoTyp'
      ],
      header: {
        text: app.$t('cp.CTRL020P170.029'),
        styleName: 'cp-tgt-header'
      }
    },
    {
      name: 'promoTgt',
      direction: 'horizontal',
      items: [
        'teuTgt',
        'revTeuTgt',
        'cm1TeuTgt'
      ],
      header: {
        text: app.$t('cp.CTRL020P170.012'),
        styleName: 'cp-tgt-header'
      }
    }
  ]

  export default {
    name: 'SfPromotionPop',
    components: {
    },
    props: {
      parentInfo: {
        type: Object,
        default: function () {
          return {
          }
        }
      }
    },
    data () {
      return {
      }
    },
    mounted () {
      this.getSfInfo()

      const $vm = this

      const grid = createGrid('realgrid', {
        header: {
          heights: [22, 23],
          showTooltip: false
        },
        displayOptions: {
          rowHeight: 35,
          fitStyle: 'even',
          hscrollBar: true,
          selectionStyle: 'block',
          columnMovable: false
        },
        stateBar: { visible: true },
        rowIndicator: { visible: false },
        checkBar: { visible: false },
        sortingOptions: {
          textCase: 'insensitive',
          keepFocusedRow: true,
          style: 'inclusive',
          showSortOrder: true
        },
        filteringOptions: { enabled: false },
        editOptions: { commitByCell: true },
        pasteOptions: {
          checkDomainOnly: true,
          checkReadOnly: true,
          enableAppend: false
        }
      })
      gridView = grid.gridView
      provider = grid.provider
      gridView.footers.visible = false
      gridView.onEditCommit = (_grid, _index, oldValue, newValue) => {
        if (typeof oldValue === 'string') {
          return true
        } else if (['', null, undefined].includes(newValue)) {
          return false
        }
      }
      gridView.onCellPasting = (_grid, _index, value) => {
        const selection = gridView.getSelectionsData()
        const selectedColumnList = Object.keys(selection[0])
        const notSelectColumnList = ['sfCntrSz', 'sfCntrTyp', 'sfRoute', 'sfVsl', 'sfVoyage', 'sfLostReason', 'sfCargoTyp']
        const isInvalidColumnSelected = notSelectColumnList.filter(column => selectedColumnList.includes(column)).length !== 0

        if (isInvalidColumnSelected || ['', null, undefined].includes(value) || Number.isNaN(parseInt(value))) {
          return false
        }
      }

      // 그리드 정보 전처리
      $vm.setInfo()

      // 그리드 필드 생성
      provider.setFields([countryfield, ...$vm.parentInfo.sfOpt.fields, ...fields])
      gridView.setColumns([countryColumn, ...$vm.parentInfo.sfOpt.columns, ...columns])

      // 컬럼 순서 조정
      const refColumnIdx = $vm.parentInfo.sfOpt.columnLayout.map(elem => elem.column).indexOf('dlyPlc') + 1
      gridView.setColumnLayout(['country', ...$vm.parentInfo.sfOpt.columnLayout.slice(0, refColumnIdx), ...layout, ...$vm.parentInfo.sfOpt.columnLayout.slice(refColumnIdx)])

      // 데이터 처리 및 그리드 생성
      $vm.setGridList()
    },
    methods: {
      async getSfInfo () {
        const mapper = {
          sfCntrSz: 'CPSF01',
          sfCntrTyp: 'CPSF02',
          sfRoute: 'CPSF03',
          sfLostReason: 'CPSF04',
          sfCargoTyp: 'CPSF05',
          sfVsl: 'CPSF06'
        }

        const promiseList = []
        for (const [key, code] of Object.entries(mapper)) {
          const promise = cpCommonInfo.cpCommonCodeList(code).then(response => {
            const data = {
              name: key,
              data: response.data
            }
            return data
          }).catch(err => {
            console.log(err)
          })
          promiseList.push(promise)
        }

        await Promise.allSettled(promiseList).then(responseList => {
          for (const response of responseList) {
            gridView.columnByName(response.value.name).values = response.value.data.map(elem => elem.detailCd)
          }
        }).catch(e => {
          console.error('promise-all', e)
        })
      },
      setInfo () {
        const renameMapper = {
          porCtr: this.$t('cp.CTRL020P170.013'),
          porPlc: this.$t('cp.CTRL020P170.014'),
          dlyCtr: this.$t('cp.CTRL020P170.015'),
          dlyPlc: this.$t('cp.CTRL020P170.016')
        }

        for (const row of this.parentInfo.sfOpt.columns) {
          if (Object.keys(renameMapper).includes(row.name)) {
            row.visible = true
            row.header.text = renameMapper[row.name]
            row.header.template = renameMapper[row.name]
          }
        }
      },
      setGridList () {
        const sfRow = {
          promotionOwner: this.$store.state.auth.loginInfo.userId,
          teuTgt: 0,
          revTeuTgt: 0,
          cm1TeuTgt: 0,
          sfCntrSz: '',
          sfCntrTyp: '',
          sfRoute: '',
          sfVsl: '',
          sfVoyage: '',
          sfLostReason: '',
          sfCargoTyp: ''
        }

        const gridList = this.parentInfo.sfOpt.gridList.map(row => Object.assign({}, row, sfRow))
        provider.setRows(gridList)
      },
      async runPromotion () {
        const promotionList = gridView.getJsonRows(0, -1).map(row => ({
          scenarioCd: this.parentInfo.sfOpt.groupKeyCheck.scenarioCd,
          country: row.porCtr,
          porCtr: row.porCtr,
          porPlc: row.porPlc,
          dlyCtr: row.dlyCtr,
          dlyPlc: row.dlyPlc,
          sfCntrSz: row.sfCntrSz,
          sfCntrTyp: row.sfCntrTyp,
          sfRoute: row.sfRoute,
          sfVsl: row.sfVsl,
          sfVoyage: row.sfVoyage,
          sfLostReason: row.sfLostReason,
          sfCargoTyp: row.sfCargoTyp,
          promotionOwner: row.promotionOwner,
          teuTgt: row.teuTgt,
          revTeuTgt: row.revTeuTgt,
          cm1TeuTgt: row.cm1TeuTgt
        }))

        await scenarioTargetSet.salesforcePromotion(promotionList).then(response => {
          switch (response.data) {
            case 'OK': {
              this.openAlert(this.$t('cp.CTRL020P170.017'))
              break
            }
            case 'NO': {
              this.openAlert(this.$t('cp.CTRL020P170.018'))
              break
            }
            case 'ING': {
              this.openAlert(this.$t('cp.CTRL020P170.019'))
              break
            }
            default: {
              const sfErrorContainer = document.createElement('div')
              sfErrorContainer.setAttribute('class', 'cp-inner-container cp-scroll cp-scroll--auto mt10')
              const txt = document.createTextNode(response.data)
              sfErrorContainer.appendChild(txt)
              const msg = `${this.$t('cp.CTRL020P170.020')}<br>${sfErrorContainer.outerHTML}`
              this.openAlert(msg)
              break
            }
          }
        }).catch(err => {
          console.log(err)
        })
      },
      layerClose () {
        this.$emit('close')
        $('.popup_dim').fadeOut()
        $('body,html').removeAttr('style')
        return false
      },
      openAlert (msg) {
        let obj = {
          alertType: 'simple',
          onClose: this.closeFun,
          customCloseBtnClass: 'button blue lg simplert-test1',
          customCloseBtnText: this.$t('cp.COMMON.005'),
          useIcon: false,
          customClass: 'simple_alert',
          message: msg,
          type: 'info'
        }
        this.$ekmtcCommon.alert(obj)
      },
      async asyncAlert (msg) {
        let obj = {
          alertType: 'normal',
          showXclose: true,
          customCloseBtnClass: 'button blue lg',
          customCloseBtnText: this.$t('cp.COMMON.007'),
          customConfirmBtnText: this.$t('cp.COMMON.005'),
          customConfirmBtnClass: 'button blue lg',
          useConfirmBtn: true,
          title: this.$t('cp.CTRL020P170.021'),
          message: msg,
          type: 'info'
        }
        gridView.commit()
        if (await this.$ekmtcCommon.asyncAlert(obj)) {
          this.runPromotion()
        }
      }
    }
  }
</script>
<style>
  .cp-popinfo {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .cp-popinfo > div > span {
    display: inline-block;
  }

  .cp-popinfo > div > span:first-child {
    color: #075bb9;
    font-weight: 500;
    margin-right: 30px;
  }

  .cp-parentnode .rg-renderer {
    max-width: 100% !important;
  }

  .rg-button-list,
  .rg-button-list:hover,
  .rg-button-list:active:hover {
    background: url(data:image/png;base64,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) no-repeat right 50%;
  }

  .rg-dropdown-select,
  .rg-dropdown-item:hover {
    background-color: #eaebf2 !important;
    color: #075bb9 !important;
  }
</style>
